// React import
import React from 'react';
// Styles import
import '../../util.css'
import './Preloader.css'

class Preloader extends React.Component {

    render () {

        return (
            <div className={"preloader noselect"}>
                <div className="load">
                    <div>G</div>
                    <div>N</div>
                    <div>I</div>
                    <div>D</div>
                    <div>A</div>
                    <div>O</div>
                    <div>L</div>
                </div>
            </div>

        );
    }

}

export default Preloader;
